import { render, staticRenderFns } from "./UTestimonials.vue?vue&type=template&id=87593096&scoped=true&"
import script from "./UTestimonials.vue?vue&type=script&lang=js&"
export * from "./UTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./UTestimonials.vue?vue&type=style&index=0&id=87593096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87593096",
  null
  
)

export default component.exports